import React, {useState} from 'react';
import { ResponsiveLine } from '@nivo/line'

const RayChartLine = ({ data, category, indexBy, options, callbackLegends = null }) => {

    return <div style={{height: options.height}}>
        <ResponsiveLine
            data={data}
            keys={category}
            indexBy = {indexBy}
            onClick = {options.handleClick}
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            padding={0.3}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={[
                '#38c1ff',
                '#00bcd4',
                '#cddc39',
                '#6ddbdb',
                '#8bc34a',
                '#fad55c',
                '#68c182',
                '#cb94d9',
                '#f5b2d8',
                '#f2aba1',
                '#8ce7ce',
                '#97b4f4',
                '#fabd5c',
                '#f69679',
                '#fdc689',
                '#fff799',
                '#c4df9b',
                '#82ca9c',
                '#76ccc7',
                '#6dcff6',
                '#7da7d9',
                '#8393ca',
                '#8781bd',
                '#a186be',
                '#bd8cbf',
                '#f49ac1',
                '#f5989d',
                '#c7b299',
                '#998675',
                '#c69c6d'
            ]}
			useMesh={true}
            fill={[]}
            borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
            labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    toggleSerie: true,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1
                            }
                        }
                    ],
                    onClick: (d) => {
                        callbackLegends && callbackLegends(d)
                    },
                }
            ]}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
        />
    </div>
};

export default RayChartLine;